export default function Pager({
  page,
  pages,
  onPage,
}: {
  page: number
  pages: number
  onPage: (page: number) => void
}) {
  if (pages <= 1) return null
  return (
    <div className="mt-4 flex items-center justify-between gap-3">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
        className="text-[11px] tracking-[0.16em] text-muted uppercase hover:text-ink disabled:opacity-40 disabled:hover:text-muted"
      >
        Previous
      </button>
      <p className="text-[12px] text-muted">
        Page {page} of {pages}
      </p>
      <button
        type="button"
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
        className="text-[11px] tracking-[0.16em] text-muted uppercase hover:text-ink disabled:opacity-40 disabled:hover:text-muted"
      >
        Next
      </button>
    </div>
  )
}
